import React from 'react';

import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent } from './styles';

// A generic modal that can display some text and confirm or cancel
export default React.memo(({ title, text, onConfirm, onCancel, isOpen = true, loading = false }) => {
  return (
    <Modal isOpen={isOpen}>
      {title && <Header>{title}</Header>}
      <Body loading={loading}>{text && <ModalContent>{text}</ModalContent>}</Body>
      <Footer>
        {onCancel && <FooterButton label="Cancel" onClick={onCancel} />}
        {<FooterButton label="Confirm" onClick={onConfirm} disabled={loading} />}
      </Footer>
    </Modal>
  );
});
